import { useQuery } from '@tanstack/react-query';
import { infraGraphApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business infra-graph 俯瞰（stack サマリ + cross-stack 集約エッジ）取得フック。TanStack Query でキャッシュ管理。
 * @graph-connects infraGraphApi [calls] infra-graph 俯瞰 API クライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Query キー生成
 */
export function useInfraGraphOverview() {
  return useQuery({
    queryKey: queryKeys.infraGraph.overview(),
    queryFn: infraGraphApi.getOverview,
  });
}

/**
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business infra-graph stack 詳細（リソースノード + stack 内エッジ）取得フック。stack 指定時のみ有効化。
 * @graph-connects infraGraphApi [calls] infra-graph stack 詳細 API クライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Query キー生成
 */
export function useInfraGraphStack(stack: string | null) {
  const safeStack = stack ?? '';
  return useQuery({
    queryKey: queryKeys.infraGraph.stack(safeStack),
    queryFn: () => infraGraphApi.getStack(safeStack),
    enabled: stack !== null,
  });
}
